export default {
  save: 'ذخیره',
  addRole: 'اضافه کردن سمت جدید',
  noRoles: 'سمتی برای شرکت تعریف نشده است',
  rolesAccess: 'ایجاد دسترسی سریع برای سمت‌های زیر:',
};
